import { isString } from "lodash";


export const downloadData = (data: any, fileName: string = new Date().getTime().toString() + ".txt", downloadMimeType: string = 'text/csv',) => {
    if (isString(data)) {
        let anchorEl = null;
        try {
            const blob = new Blob([data], { type: downloadMimeType });
            const url = window.URL.createObjectURL(blob);
            anchorEl = document.createElement("a");
            anchorEl.setAttribute("href", url);
            anchorEl.setAttribute("download", fileName);
            anchorEl.click();
        }
        catch (ex) {
            console.log(ex);
        }
        finally {
            if (anchorEl) {
            }
        }
    }
    else {
        alert(data?.message);
    }
}